import Check from '@material-ui/icons/Check';
import Add from '@material-ui/icons/Add';
import React from 'react';
import styles from 'assets/jss/material-dashboard-pro-react/views/users/detailsStyle';
import { makeStyles } from '@material-ui/core/styles';
import { hexToRgb } from 'assets/jss/material-dashboard-pro-react';
import { Caption } from 'components/Typography/Typography';

// @ts-ignore
const useStyles = makeStyles(styles);

interface IDepartmentBadgeProps {
	name: string;
	hexColor: string;
	checked: boolean;
	onClick: (event: any) => void;
}

const DepartmentBadge = ({ name, hexColor, checked = false, onClick }: IDepartmentBadgeProps) => {
	const classes = useStyles();

	const Icon = checked ? Check : Add;
	return (
		<div
			style={{
				backgroundColor: `rgba(${hexToRgb(hexColor)}, ${checked ? '1' : '0.5'})`,
			}}
			className={classes.departmentBadge}
			onClick={onClick}
		>
			<Caption color="primary-dark" inline disableMargin>
				{name}
			</Caption>
			<Icon className={classes.departmentBadgeIcon} />
		</div>
	);
};

export default DepartmentBadge;
